var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"section",staticClass:"padded-container"},[_c('div',{staticClass:"aa-funnel-grid aa-funnel-grid--reseller"},[_c('div',[_c('LoadingSpinner')],1),_vm._v(" "),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3'),_vm._v(" "),_c('div')])
}]

export { render, staticRenderFns }